import { useEffect, useRef } from 'react';
import { companyService } from '@root/app/shared/new-services/company.service';
import { authService } from '@root/app/shared/new-services/auth.service';

export const useHotjarOnboarding = (): void => {
    const triggeredRef = useRef(false);

    useEffect(() => {
        if (!authService.isLoggedIn() || triggeredRef.current) {
            return;
        }

        const hj = (window as unknown as { hj?: (...args: unknown[]) => void }).hj;
        if (!hj) {
            return;
        }

        companyService.getUserCompany((err, company) => {
            if (err || !company || triggeredRef.current) {
                return;
            }
            const status = company.launchStatus;
            if (status === 'CREATED' || status === 'PRELAUNCH') {
                hj('trigger', 'in_onboarding');
                triggeredRef.current = true;
            }
        });
    }, []);
};
